const DateInput = ({ title = "Fecha", value, action, setter, disabled = false }) => {

  const toInputValue = (val) => {
    if (!val) return "";
    if (val instanceof Date) return val.toISOString().slice(0, 10);
    // Asumimos string tipo YYYY-MM-DD
    return String(val).slice(0, 10);
  };

  const handleChange = (e) => {
    const newValue = e.target.value; // YYYY-MM-DD
    if (setter) {
      setter(newValue);
    } else if (action) {
      action(newValue);
    }
  };

  return (
    <div className="flex flex-row items-center justify-center gap-4">
      <span className="text-xs">{title}</span>
      <input 
        type="date" 
        className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
        value={toInputValue(value)}
        onChange={handleChange}
        disabled={disabled}
      />
    </div>  
  )
}

export default DateInput;